module.exports = __webpack_public_path__ + "static/images/ad.633eb35.jpg";